import * as accountApi from '@/network/api/accounts.api.js'

/** requests Accounts Balance
@return {promise} - Accounts Balance request
*/
export const requestAccountsBalances = async (context, payload) => {
    const res = await accountApi.requestAccountsBalances(payload)
    if (res) {
        const data = res.data.data
        context.commit('SAVE_ACCOUNTS_BALANCE', data)
    }
    return res
}

/** requests Account Detail
@return {promise} - Accounts Detail request
*/
export const requestAccountDetails = async (context, payload) => {
    const res = await accountApi.requestAccountDetails(payload)

    return res
}

/** requests Account Detail Update
@return {promise} - Accounts Detail Update request
*/
export const updateAccountDescription = async (context, payload) => {
    const res = await accountApi.updateAccountDescription(payload)
    if (res) context.commit('SAVES_NEW_ACCOUNT_DESCRIPTION', { payload, responseData: res.data.data })
    return res
}
